import Backbone from 'backbone';

import template from './audienceVNext.pug';

export class AudienceContextualAttributeViewVNext extends Backbone.View {
  initialize({
    deps,
    i18n,
    targetId,
    isMCC,
  }) {
    this.deps = deps;
    this.i18n = i18n;
    this.isMCC = isMCC;
    this.audienceId = targetId;
    this.reachSize = '';
  }


  render({
    showDeliveryStatusPopup,
    recommendationAccountId,
  }) {
    const {
      deps,
      i18n,
      audienceId,
    } = this;
    const options = this.isMCC ?
      {
        entitySet:
          deps
            .edmCampaign
            .currentCustomer
            .Accounts
            .$withKey(Number(recommendationAccountId))
            .Audiences,
      } : {};

    deps.jsdata.Audience.find(
      audienceId,
      options
    ).then((response) => {
      if (response) {
        this.reachSize = i18n.getString('Audience_Reach_Size', {
          reachSize: response.Reach || i18n.getString('Contextual_Response_Null'),
        });
        this.$el.html(template({ reachSize: this.reachSize }));

        showDeliveryStatusPopup(this.el.outerHTML);
      }
    });
    return this;
  }
}
